import React from 'react';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import ReactDOM from 'react-dom/client';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';

// CRITICAL: Enable OAuth listener for Amplify v6
// This side-effect import is REQUIRED for signInWithRedirect to work properly.
// It intercepts the OAuth callback (code/state params) and completes the token exchange.
// Must be imported BEFORE configureAmplify() is called.
// See: https://docs.amplify.aws/gen1/react/build-a-backend/auth/auth-migration-guide/
import 'aws-amplify/auth/enable-oauth-listener';

import App from './App';
import { configureAmplify } from './lib/amplify';
import { theme, cssVariablesResolver } from './theme';

// Configure AWS Amplify with backend resources
configureAmplify();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MantineProvider theme={theme} cssVariablesResolver={cssVariablesResolver}>
      <ModalsProvider>
        <Notifications position="top-right" />
        <App />
      </ModalsProvider>
    </MantineProvider>
  </React.StrictMode>
);
